import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlusRoutingModule } from './plus-routing.module';
import { PlusSystemComponent } from './plus-system/plus-system.component';
import { PlusGalleryComponent } from './plus-gallery/plus-gallery.component';
import { PlusNoticeComponent } from './plus-notice/plus-notice.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule } from '@angular/forms';
import { ComponentsModule } from '@app/components/components.module';
import { PipeModule } from '@app/pipes/pipe.module';
import { TranslateModule } from '@ngx-translate/core';
import { PlusGalleryDetailsComponent } from './plus-gallery-details/plus-gallery-details.component';
import { PlusMapComponent } from './plus-map/plus-map.component';
import { PlusNoticeDetailsComponent } from './plus-notice-details/plus-notice-details.component';
import { HomeIndexModule } from '@app/home-page/home-page/home-index.module';



@NgModule({
  declarations: [
    PlusSystemComponent,
    PlusGalleryComponent,
    PlusNoticeComponent,
    PlusGalleryDetailsComponent,
    PlusMapComponent,
    PlusNoticeDetailsComponent
  ],
  imports: [
    CommonModule,
    PlusRoutingModule,
    NgxPaginationModule,
    FormsModule,
    ComponentsModule,
    PipeModule,
    TranslateModule,
    HomeIndexModule
  ],
  exports: [
    PlusMapComponent
  ]
})
export class PlusModule { }
